module.exports = __webpack_public_path__ + "img/niarte.cdaf8397.webp";